import { FunctionComponent, useContext, useEffect, useRef } from "react";
import { useAppSelector } from "./store/hooks";
import { ActionsContext } from "./ActionsContext";
import { isCurrentPlayer } from "./Utils";
import { GameState } from "./store/gameStateSlice";
import SoundService from "./services/SoundService";

type RollButtonProps = {
  onRollButtonClicked: Function;
};

const AUTO_DICE_DELAY_MS = 600;

const RollButton: FunctionComponent<RollButtonProps> = ({
  onRollButtonClicked,
}) => {
  const [gameState, players, currentPlayer, autoDice] =
    useAppSelector((state) => [
      state.gameState,
      state.players,
      state.currentPlayer,
      state.settings.autoDice,
    ]);
  const actions  = useContext(ActionsContext);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const isMyTurn =
    gameState === GameState.PlayerRolling &&
    isCurrentPlayer(players, currentPlayer, actions);

  const doRoll = async () => {
    SoundService.instance.play("dice");
    onRollButtonClicked();
    await actions.rollButtonClicked();
  };

  // Автобросок
  useEffect(() => {
    if (isMyTurn && autoDice) {
      timerRef.current = setTimeout(doRoll, AUTO_DICE_DELAY_MS);
    }
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMyTurn, autoDice]);

  if (!isMyTurn) return null;

  if (autoDice) {
    return (
      <div className="Roll-button-wrapper">
        <div className="Roll-auto-indicator">
          <div className="Roll-auto-dot" />
          Бросок...
        </div>
      </div>
    );
  }

  return (
    <div className="Roll-button-wrapper">
      <button
        className="Roll-button"
        onClick={doRoll}
      >
        Бросить кости
      </button>
    </div>
  );
};

export default RollButton;
